module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container mb-50"
  }, [_vm._m(0), _vm._v(" "), _c('h1', {
    staticClass: "domore-blue-2-light"
  }, [_vm._v(_vm._s(_vm.$t("partners.title")))]), _vm._v(" "), _vm._m(1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "center"
  }, [_c('img', {
    attrs: {
      "src": require("assets/img/star.png")
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "center"
  }, [_c('img', {
    staticClass: "max-width-100",
    attrs: {
      "src": require("assets/img/partnerzy.png")
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2d6beb1d"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Partners.vue
// module id = 791
// module chunks = 1